import {mapGetters} from "vuex";

export default {
    name: 'linked-account-item',
    props: {
        provider: {
            type: String,
            default: ''
        },
        providerName: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            openMenu: false
        }
    },
    computed: {
        ...mapGetters({
            user: `user/user`,
            linkAccountRequest: 'userContacts/linkAccountRequest',
            unlinkAccountRequest: 'userContacts/unlinkAccountRequest',
        }),
    },
}
